import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Carousel from '@gcc/pip-components/dist/Carousel';
import {
  Root,
  AccSectionHeader,
  AccSectionBody,
  ChevronSign,
  ChevronWrapper,
  CollapsibleHeader,
  CarouselWrapper,
  FlexStretchDiv,
} from './optionGroupStyles';

const HeaderObject = (
  <CollapsibleHeader id="SurfaceMaterialOption" className="flex-wrap-dependent-options">
    <ChevronWrapper>
      <ChevronSign />
    </ChevronWrapper>
    <div>
      <div className="row-header">
        <div className="row-header__title">
          <div className="sui-h2-bold sui-line-clamp-unset sui-text-primary">
            Surface Material
          </div>
        </div>
      </div>
      <div className="subQuestion">
        <p>
          <strong>Interested in a different surface material? </strong>
          Click here to compare materials! We&apos;ll save your measurements so you can focus on selecting the perfect
          countertop tailored to your design and&nbsp;budget.
        </p>
      </div>
    </div>
  </CollapsibleHeader>
);

const SurfaceMaterialOptionGroup = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const classes = classNames({
    isCollapsed,
  });

  return children.length > 0 && (
    <Root id="SurfaceMaterial" className={classes}>
      <AccSectionHeader onClick={() => setIsCollapsed(!isCollapsed)}>
        {HeaderObject}
      </AccSectionHeader>
      <AccSectionBody>
        <CarouselWrapper>
          <FlexStretchDiv>
            <Carousel>
              {children}
            </Carousel>
          </FlexStretchDiv>
        </CarouselWrapper>
      </AccSectionBody>
    </Root>
  );
};

SurfaceMaterialOptionGroup.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SurfaceMaterialOptionGroup;
